export const SET_QUOTE_PAGE = "setQuotePage";
